import { render } from "./DetailRiwayatPenjualan_c.vue?vue&type=template&id=1e4d59c8&scoped=true"
import script from "./DetailRiwayatPenjualan_c.vue?vue&type=script&lang=js"
export * from "./DetailRiwayatPenjualan_c.vue?vue&type=script&lang=js"

import "./DetailRiwayatPenjualan_c.vue?vue&type=style&index=0&id=1e4d59c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e4d59c8"

export default script